import { buildProps as r, definePropType as a } from "./index601.js";
import { useAriaProps as i } from "./index650.js";
import { isNumber as l } from "./index565.js";
const d = r({
  /**
   * @description trigger distance(px)
   */
  distance: {
    type: Number,
    default: 0
  },
  /**
   * @description height of scrollbar
   */
  height: {
    type: [String, Number],
    default: ""
  },
  /**
   * @description max height of scrollbar
   */
  maxHeight: {
    type: [String, Number],
    default: ""
  },
  /**
   * @description whether to use the native scrollbar
   */
  native: Boolean,
  /**
   * @description style of wrap
   */
  wrapStyle: {
    type: a([String, Object, Array]),
    default: ""
  },
  /**
   * @description class of wrap
   */
  wrapClass: {
    type: [String, Array],
    default: ""
  },
  /**
   * @description class of view
   */
  viewClass: {
    type: [String, Array],
    default: ""
  },
  /**
   * @description style of view
   */
  viewStyle: {
    type: [String, Array, Object],
    default: ""
  },
  /**
   * @description do not respond to container size changes, if the container size does not change, it is better to set it to optimize performance
   */
  noresize: Boolean,
  // 如果 container 尺寸不会发生变化，最好设置它可以优化性能
  /**
   * @description element tag of the view
   */
  tag: {
    type: String,
    default: "div"
  },
  /**
   * @description always show
   */
  always: Boolean,
  /**
   * @description minimum size of scrollbar
   */
  minSize: {
    type: Number,
    default: 20
  },
  /**
   * @description Wrap tabindex
   */
  tabindex: {
    type: [String, Number],
    default: void 0
  },
  /**
   * @description id of view
   */
  id: String,
  /**
   * @description role of view
   */
  role: String,
  ...i(["ariaLabel", "ariaOrientation"])
}), s = {
  "end-reached": (e) => ["left", "right", "top", "bottom"].includes(e),
  scroll: ({
    scrollTop: e,
    scrollLeft: t
  }) => [e, t].every(l)
};
export {
  s as scrollbarEmits,
  d as scrollbarProps
};
